/**
 * Thumbs-down glyph used by the message-feedback row. Uses
 * `currentColor` so the enclosing `IconButton` controls tinting.
 *
 * The path data is transcribed directly from the GA-Sidekick Figma
 * source (asset hash `a67bcdf74528941637131105044c57892367566a`). The
 * Figma artwork's native viewBox is `14.4721 x 14.8333`; it is
 * centered inside a 24x24 viewBox via a `translate(4.7639, 4.5835)`
 * group so the icon matches the visual scale of the package's other
 * 24x24 glyphs (e.g. `SendArrowIcon`, `CloseGlyph`).
 */
export type ThumbsDownIconProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function ThumbsDownIcon({ size = 24, className }: ThumbsDownIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(4.7639 4.5835)">
        <path
          d="M10.3887 0.750002V8.08333M13.7221 5.95V2.88333C13.7221 2.1366 13.7221 1.76323 13.5768 1.47801C13.4489 1.22713 13.245 1.02316 12.9941 0.895326C12.7089 0.750002 12.3355 0.750002 11.5887 0.750002H4.46742C3.4931 0.750002 3.00594 0.750002 2.61247 0.928291C2.26568 1.08543 1.97095 1.33828 1.76291 1.65715C1.52686 2.01893 1.45279 2.50043 1.30463 3.46342L0.955916 5.73008C0.760512 7.00021 0.66281 7.63527 0.851285 8.12942C1.01671 8.56313 1.32785 8.9258 1.73136 9.15525C2.1911 9.41667 2.83364 9.41667 4.11871 9.41667H4.65542C5.02878 9.41667 5.21547 9.41667 5.35808 9.48933C5.48352 9.55325 5.58551 9.65523 5.64942 9.78067C5.72208 9.92328 5.72208 10.11 5.72208 10.4833V12.4394C5.72208 13.3473 6.45808 14.0833 7.36598 14.0833C7.58252 14.0833 7.77876 13.9558 7.86671 13.7579L10.1072 8.71679C10.2091 8.4875 10.2601 8.37286 10.3406 8.28879C10.4118 8.21449 10.4992 8.15767 10.596 8.12279C10.7056 8.08333 10.831 8.08333 11.0819 8.08333H11.5887C12.3355 8.08333 12.7089 8.08333 12.9941 7.93801C13.245 7.81018 13.4489 7.6062 13.5768 7.35532C13.7221 7.07011 13.7221 6.69674 13.7221 5.95Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default ThumbsDownIcon;
